import Vue from 'vue'
import { BvDataCenterContext } from '../..'

export abstract class DataCenter_StoreType<K, T> {

  context: BvDataCenterContext

  _pool = {} as Record<number | string, T>

  constructor (context: BvDataCenterContext) {
    this.context = context
  }

  cleanup () {
    this._pool = {}
  }

  protected _key?: (id: K) => string

  protected get mainStore () {
    return this.context.mainStore
  }

  protected get pubsub () {
    return this.context.pubsub
  }

  get (id: K): T | undefined {
    const key = (this._key?.(id) ?? id) as number | string
    return this._pool[key]
  }

  set (id: K, value: T) {
    const key = (this._key?.(id) ?? id) as number | string
    Vue.set(this._pool, key, value)
  }

  has (id: K) {
    const key = (this._key?.(id) ?? id) as number | string
    return !!this._pool[key]
  }

  remove (id: K) {
    const key = (this._key?.(id) ?? id) as number | string
    Vue.delete(this._pool, key)
  }

  get values (): T[] {
    return Object.values(this._pool)
  }

  // protected abstract get vuexModulePath (): string | undefined

  // private initVuexModule () {
  //   const path = this.vuexModulePath
  //   if (!path) {
  //     return
  //   }
  //   if (this.vuexStore.hasModule(path)) {
  //     console.error('already registered', path)
  //     return
  //   }

  //   const module = createModule<T>()
  //   this.vuexStore.registerModule(path, module)
  //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   return (this.vuexStore.state as any)[path] as DataCenter_StoreState<T>
  // }

  // private cleanupVuexModule () {
  //   const path = this.vuexModulePath
  //   if (path) {
  //     this.vuexStore.unregisterModule(path)
  //   }
  // }


}
